const config = {
    // Google Maps
    googleMaps: {
      apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    },
    billing: {
      // Accepts 'upfront' (current Stripe flow) or 'post_hire' (pay later flow)
      jobBillingMode: (process.env.VUE_APP_JOB_BILLING_MODE || 'post_hire').toLowerCase(),
    },
  };
  
  // Validation for required variables
  const requiredVariables = [
    'VUE_APP_GOOGLE_MAPS_API_KEY'
  ];
  
  requiredVariables.forEach(variable => {
    if (!process.env[variable]) {
    //   console.warn(`⚠️  Missing required environment variable: ${variable}`);
    //   if (config.app.environment === 'production') {
        console.error(`❌ Required variable ${variable} is missing!`);
    //   }
    }
  });
  
  // Make sure Google Maps API key is available
  if (!config.googleMaps.apiKey) {
    console.warn('Google Maps API key is missing. Map functionality will be disabled.');
  }
  
  export default config;
